class CollectionScrollPosition {
  constructor () {
    // Last clicked item (product) href
    this.lastClickedItemHrefKey =
      'collectionScrollPosition-lastClickedItemHref'
    this.lastClickedItemHref = sessionStorage.getItem(
      this.lastClickedItemHrefKey,
    )

    // Collection URL where the last click happened
    this.lastClickedCollectionUrlKey =
      'collectionScrollPosition-lastClickedCollectionUrl'
    this.lastClickedCollectionUrl = sessionStorage.getItem(
      this.lastClickedCollectionUrlKey,
    )

    // Last visited collection page (pagination)
    this.lastVisitedUrlsPageKey =
      'collectionScrollPosition-lastVisitedCollectionUrlPage'
    this.lastVisitedUrlsPage = sessionStorage.getItem(
      this.lastVisitedUrlsPageKey,
    )

    // Current URL (pathname only, no query)
    this.currentUrl = this.urlToPathName(window.location.href)

    this.initialise()
  }

  initialise () {
    const isCollection = this.currentUrl.includes('/collections/')
    const isProduct = this.currentUrl.includes('/products/')

    if (isCollection) {
      this.handleCollectionTemplate()
    } else if (isProduct) {
      // eslint-disable-next-line no-useless-return
      return
    } else {
      this.clearData()
    }
  }

  handleCollectionTemplate () {
    // Disable browser's native scrollRestoration
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual'
    }

    // If we have a stored page, ensure the URL reflects it (e.g. ?page=2)
    if (this.lastVisitedUrlsPage && this.lastVisitedUrlsPage !== '1') {
      const url = new URL(window.location.href)
      if (!url.searchParams.get('page')) {
        url.searchParams.set('page', this.lastVisitedUrlsPage)
        history.replaceState(null, '', url.toString())
      }
    }

    this.restoreScrollPosition()
    this.captureScrollPosition()
  }

  restoreScrollPosition () {
    // Only restore if:
    // 1. We have a last clicked product
    // 2. We have a collection URL associated with that click
    // 3. The current collection matches that stored collection
    if (
      !this.lastClickedItemHref ||
      this.lastClickedItemHref === 'undefined' ||
      !this.lastClickedCollectionUrl ||
      this.lastClickedCollectionUrl !== this.currentUrl
    ) {
      return
    }

    const maxTries = 20
    const scrollToElement = () => {
      const el = document.querySelector(
        `a[href="${this.lastClickedItemHref}"]`,
      )
      if (el) {
        requestAnimationFrame(() => {
          el.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'center',
          })
          el.focus?.({ preventScroll: true })

          // We’re done, clear state
          this.clearData()
        })
      } else {
        if (!this._scrollTries) this._scrollTries = 0
        if (this._scrollTries < maxTries) {
          this._scrollTries++
          setTimeout(scrollToElement, 50)
        } else {
          // Stop trying after maxTries
          this._scrollTries = 0
        }
      }
    }

    this._scrollTries = 0
    scrollToElement()
  }

  captureScrollPosition () {
    // Capture clicked item on collection pages
    window.addEventListener('click', (e) => {
      const anchor = e.target.closest('a')
      const item = e.target.closest('[data-collection-filters-el="item"]')
      if (!anchor || !item) return

      e.preventDefault()

      const href = anchor.getAttribute('href')
      const page = item.getAttribute('data-page')

      // Store the product URL
      sessionStorage.setItem(this.lastClickedItemHrefKey, href)
      this.lastClickedItemHref = href

      // Store the collection URL we are currently on (pathname only)
      const collectionPath = window.location.pathname
      sessionStorage.setItem(this.lastClickedCollectionUrlKey, collectionPath)
      this.lastClickedCollectionUrl = collectionPath

      // Store the page we were on when clicking
      if (page != null) {
        sessionStorage.setItem(this.lastVisitedUrlsPageKey, page)
        this.lastVisitedUrlsPage = page

        const currentParams = new URLSearchParams(window.location.search)
        currentParams.set('page', page)

        const newUrl = `${window.location.pathname}?${currentParams.toString()}`
        history.pushState({ page }, '', newUrl)
      }

      window.location.href = href
    })

    // Capture beforeunload event
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem(
        this.lastClickedItemHrefKey,
        this.lastClickedItemHref || '',
      )
      sessionStorage.setItem(
        this.lastClickedCollectionUrlKey,
        this.lastClickedCollectionUrl || '',
      )
    })
  }

  clearData () {
    sessionStorage.removeItem(this.lastClickedItemHrefKey)
    sessionStorage.removeItem(this.lastClickedCollectionUrlKey)
    sessionStorage.removeItem(this.lastVisitedUrlsPageKey)

    this.lastClickedItemHref = null
    this.lastClickedCollectionUrl = null
    this.lastVisitedUrlsPage = null
  }

  urlToPathName (url) {
    const object = new URL(url)
    return object.pathname
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.BAO.collectionScrollPosition = new CollectionScrollPosition()
})
